import * as tslib_1 from "tslib";
var Environment = /** @class */ (function () {
    function Environment() {
    }
    Object.defineProperty(Environment, "init", {
        get: function () {
            var env = window.environment || 'local';
            var environmentConfig = this.environments[env];
            if (window.environmentConfig) {
                environmentConfig = tslib_1.__assign({}, environmentConfig, window.environmentConfig);
            }
            return environmentConfig;
        },
        enumerable: true,
        configurable: true
    });
    Environment.environments = {
        local: {
            production: false,
            appName: 'MapCore',
            appId: 0,
            pdauthAppName: 'MapCore',
            deepLinkBaseUrl: null,
            apiBaseUrl: 'http://localhost/mapcore/api',
            printTimeout: 3600000,
            externalLayerFilterEnabled: false,
            geocodeServerUrl: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
            geocodeStartingLocation: '-76.930,40.237',
            googleMapApiUrl: 'https://maps.googleapis.com/maps/api/js?v=3.exp',
            googleMapApiKey: 'client=gme-penndotinfosystems&channel=MapCore',
            gisSearch: { baseUrl: '' },
            bingBasemaps: {
                key: 'AoY639QLAP- klpOcnuspHmBA79ZECKfeULw8NwsZbSipcKHfBmglAPmbtdsF7Umi',
                thumbnails: {
                    hybrid: '//localhost/mapcore/api/assets/bing-basemap-thumbnails/bing-hybrid.jpg',
                    street: '//localhost/mapcore/api/assets/bing-basemap-thumbnails/bing-street.jpg',
                    imagery: '//localhost/mapcore/api/assets/bing-basemap-thumbnails/bing-imagery.jpg'
                }
            },
            ags: {
                baseUrl: 'https://pddvgisweb.penndot.pa.gov/gisgp',
                exportEndpoint: '/rest/services/mapcore/mapcoregeoprocessing/GPServer/extract'
            },
            pennDotBaseMap: {
                tileUrl: 'https://gis.penndot.pa.gov/gis/rest/services/basemaps/penndotbasemap/MapServer/tile',
                thumbnailTile: '/7/48/36',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'PennDOT'
            },
            pennDotPrintBaseMapUrl: 'https://pddvgisweb.penndot.pa.gov/gisgp/rest/services/basemaps/printbasemap/MapServer',
            featureSearchKeys: [
                { prefix: 'BRIDGE_ID', column: 'bridge_id' },
                { prefix: 'BRKEY', column: 'brkey' },
                { prefix: 'MPMS PROJECT', column: 'project_id' },
                { prefix: 'SAP NOTIFICATION', column: 'notification_no' },
                { prefix: 'SR', column: 'st_rt_no' },
                { pipes: true, columns: ['cty_code', 'st_rt_no', 'seg_no'] }
            ],
            sapLayerIds: [16, 3970, 18],
            searchReplacement: [
                {
                    layerIds: [16],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Planned'
                }, {
                    layerIds: [17, 3970],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Unplanned'
                }, {
                    layerIds: [18],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Completed'
                }, {
                    layerIds: [1200],
                    replacementFormat: 'RMS Segments: {primaryText}'
                }, {
                    layerIds: [1500],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2751],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2900],
                    replacementFormat: '{primaryText}'
                }
            ],
            layers: [
                { name: 'rmsseg', id: 1299 },
                { name: 'county', id: 1 },
                { name: 'district', id: 2 },
                { name: 'municipality', id: 3 },
                { name: 'planningPartner', id: 4 },
                { name: 'congressDistrict', id: 5 },
                { name: 'senateDistrict', id: 6 },
                { name: 'houseDistrict', id: 7 },
                { name: 'intersection', id: 2902 },
                { name: 'bridgesAll', id: 1592 },
                { name: 'mpmsProjectsAll', id: 2751 },
                { name: 'hopInternal', id: 9144 },
                { name: 'hopExternal', id: 7826 },
                { name: 'tmsSites', id: 2611 },
                { name: 'petl', id: 2701 },
                { name: 'assistantAreasWinter', id: 3006 },
                { name: 'assistantAreasSummer', id: 3007 },
                { name: 'zipCode', id: 10 },
                { name: 'schoolDistrict', id: 9 },
                { name: 'stormwater', id: 7029 },
                { name: 'sapCYPlanSnapshot', id: 117051 }
            ],
            tsmoRegions: [
                {
                    type: 'tsmo',
                    name: 'western',
                    title: 'Western',
                    fullTitle: 'TSMO Western Region',
                    districtNumbers: ['01', '10', '11', '12']
                },
                {
                    type: 'tsmo',
                    name: 'central',
                    title: 'Central',
                    fullTitle: 'TSMO Central Region',
                    districtNumbers: ['02', '03', '09']
                },
                {
                    type: 'tsmo',
                    name: 'eastern',
                    title: 'Eastern',
                    fullTitle: 'TSMO Eastern Region',
                    districtNumbers: ['04', '05', '08']
                },
                {
                    type: 'tsmo',
                    name: 'southeastern',
                    title: 'Southeastern',
                    fullTitle: 'TSMO Southeastern Region',
                    districtNumbers: ['06']
                }
            ],
            paRoads: 'not used',
            geometryServiceUrl: 'https://pddvgisweb.penndot.pa.gov/gis/rest/services/Utilities/Geometry/GeometryServer',
            videoLogBaseUrl: 'https://pddvgisweb.penndot.pa.gov/videolog/',
            videoLogImagesLocation: 'https://pddvgisweb.penndot.pa.gov/videologimages',
            routingApiKey: 'AAPKbadd75f72f744f3e911d0f31cd8c6811ivUpHDn1z7baDzD5XcjoOUohYXlcpyMcsswRn2yFaK7AtZzqxoFmMDT1I_NpW3EH',
            petlCategoryId: 802,
            dataDictionaryApi: 'https://pddvgisweb.penndot.pa.gov/mapcore/api_v1/layers/1/' //'https://pddvgisweb.penndot.pa.gov/DataDictionary/api/'
        },
        dev: {
            production: false,
            appName: 'MapCore',
            appId: 0,
            pdauthAppName: 'MapCore',
            deepLinkBaseUrl: null,
            apiBaseUrl: 'https://pddvgisweb.penndot.pa.gov/mapcore/api',
            printTimeout: 3600000,
            externalLayerFilterEnabled: false,
            geocodeServerUrl: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
            geocodeStartingLocation: '-76.930,40.237',
            googleMapApiUrl: 'https://maps.googleapis.com/maps/api/js?v=3.exp',
            googleMapApiKey: 'client=gme-penndotinfosystems&channel=MapCore',
            gisSearch: { baseUrl: '' },
            bingBasemaps: {
                key: 'AoY639QLAP- klpOcnuspHmBA79ZECKfeULw8NwsZbSipcKHfBmglAPmbtdsF7Umi',
                thumbnails: {
                    hybrid: 'https://pddvgisweb.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-hybrid.jpg',
                    street: 'https://pddvgisweb.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-street.jpg',
                    imagery: 'https://pddvgisweb.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-imagery.jpg'
                }
            },
            ags: {
                baseUrl: 'https://pddvgisweb.penndot.pa.gov/gisgp',
                exportEndpoint: '/rest/services/mapcore/mapcoregeoprocessing/GPServer/extract'
            },
            pennDotBaseMap: {
                tileUrl: 'https://gis.penndot.pa.gov/gis/rest/services/basemaps/penndotbasemap/MapServer/tile',
                thumbnailTile: '/7/48/36',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'PennDOT'
            },
            pennDotPrintBaseMapUrl: 'https://pddvgisweb.penndot.pa.gov/gisgp/rest/services/basemaps/printbasemap/MapServer',
            featureSearchKeys: [
                { prefix: 'BRIDGE_ID', column: 'bridge_id' },
                { prefix: 'BRKEY', column: 'brkey' },
                { prefix: 'MPMS PROJECT', column: 'project_id' },
                { prefix: 'SAP NOTIFICATION', column: 'notification_no' },
                { prefix: 'SR', column: 'st_rt_no' },
                { pipes: true, columns: ['cty_code', 'st_rt_no', 'seg_no'] }
            ],
            sapLayerIds: [16, 3970, 18],
            searchReplacement: [
                {
                    layerIds: [16],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Planned'
                }, {
                    layerIds: [17, 3970],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Unplanned'
                }, {
                    layerIds: [18],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Completed'
                }, {
                    layerIds: [1200],
                    replacementFormat: 'RMS Segments: {primaryText}'
                }, {
                    layerIds: [1500],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2751],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2900],
                    replacementFormat: '{primaryText}'
                }
            ],
            layers: [
                { name: 'rmsseg', id: 1299 },
                { name: 'county', id: 1 },
                { name: 'district', id: 2 },
                { name: 'municipality', id: 3 },
                { name: 'planningPartner', id: 4 },
                { name: 'congressDistrict', id: 5 },
                { name: 'senateDistrict', id: 6 },
                { name: 'houseDistrict', id: 7 },
                { name: 'intersection', id: 2902 },
                { name: 'bridgesAll', id: 1592 },
                { name: 'mpmsProjectsAll', id: 2751 },
                { name: 'hopInternal', id: 9144 },
                { name: 'hopExternal', id: 7826 },
                { name: 'tmsSites', id: 2611 },
                { name: 'petl', id: 2701 },
                { name: 'assistantAreasWinter', id: 3006 },
                { name: 'assistantAreasSummer', id: 3007 },
                { name: 'zipCode', id: 10 },
                { name: 'schoolDistrict', id: 9 },
                { name: 'stormwater', id: 7029 },
                { name: 'sapCYPlanSnapshot', id: 117051 }
            ],
            tsmoRegions: [
                {
                    type: 'tsmo',
                    name: 'western',
                    title: 'Western',
                    fullTitle: 'TSMO Western Region',
                    districtNumbers: ['01', '10', '11', '12']
                },
                {
                    type: 'tsmo',
                    name: 'central',
                    title: 'Central',
                    fullTitle: 'TSMO Central Region',
                    districtNumbers: ['02', '03', '09']
                },
                {
                    type: 'tsmo',
                    name: 'eastern',
                    title: 'Eastern',
                    fullTitle: 'TSMO Eastern Region',
                    districtNumbers: ['04', '05', '08']
                },
                {
                    type: 'tsmo',
                    name: 'southeastern',
                    title: 'Southeastern',
                    fullTitle: 'TSMO Southeastern Region',
                    districtNumbers: ['06']
                }
            ],
            paRoads: 'not used',
            geometryServiceUrl: 'https://pddvgisweb.penndot.pa.gov/gis/rest/services/Utilities/Geometry/GeometryServer',
            videoLogBaseUrl: 'https://pddvgisweb.penndot.pa.gov/videolog/',
            videoLogImagesLocation: 'https://pddvgisweb.penndot.pa.gov/videologimages',
            routingApiKey: 'AAPKbadd75f72f744f3e911d0f31cd8c6811ivUpHDn1z7baDzD5XcjoOUohYXlcpyMcsswRn2yFaK7AtZzqxoFmMDT1I_NpW3EH',
            petlCategoryId: 802,
            dataDictionaryApi: 'https://pddvgisweb.penndot.pa.gov/mapcore/api_v1/layers/1/' //'https://pddvgisweb.penndot.pa.gov/DataDictionary/api/'
        },
        test: {
            production: false,
            appName: 'MapCore',
            appId: 0,
            pdauthAppName: 'MapCore',
            deepLinkBaseUrl: null,
            apiBaseUrl: 'https://gistest.penndot.pa.gov/mapcore/api',
            printTimeout: 3600000,
            externalLayerFilterEnabled: false,
            geocodeServerUrl: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
            geocodeStartingLocation: '-76.930,40.237',
            googleMapApiUrl: 'https://maps.googleapis.com/maps/api/js?v=3.exp',
            googleMapApiKey: 'client=gme-penndotinfosystems&channel=MapCore',
            gisSearch: { baseUrl: '' },
            bingBasemaps: {
                key: 'AoY639QLAP- klpOcnuspHmBA79ZECKfeULw8NwsZbSipcKHfBmglAPmbtdsF7Umi',
                thumbnails: {
                    hybrid: 'https://gistest.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-hybrid.jpg',
                    street: 'https://gistest.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-street.jpg',
                    imagery: 'https://gistest.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-imagery.jpg'
                }
            },
            ags: {
                baseUrl: 'https://gistest.penndot.pa.gov/gisgp',
                exportEndpoint: '/rest/services/mapcore/mapcoregeoprocessing/GPServer/extract'
            },
            pennDotBaseMap: {
                tileUrl: 'https://gis.penndot.pa.gov/gis/rest/services/basemaps/penndotbasemap/MapServer/tile',
                thumbnailTile: '/7/48/36',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'PennDOT'
            },
            pennDotPrintBaseMapUrl: 'https://gistest.penndot.pa.gov/gisgp/rest/services/basemaps/printbasemap/MapServer',
            featureSearchKeys: [
                { prefix: 'BRIDGE_ID', column: 'bridge_id' },
                { prefix: 'BRKEY', column: 'brkey' },
                { prefix: 'MPMS PROJECT', column: 'project_id' },
                { prefix: 'SAP NOTIFICATION', column: 'notification_no' },
                { prefix: 'SR', column: 'st_rt_no' },
                { pipes: true, columns: ['cty_code', 'st_rt_no', 'seg_no'] }
            ],
            sapLayerIds: [16, 3970, 18],
            searchReplacement: [
                {
                    layerIds: [16],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Planned'
                }, {
                    layerIds: [17, 3970],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Unplanned'
                }, {
                    layerIds: [18],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Completed'
                }, {
                    layerIds: [1200],
                    replacementFormat: 'RMS Segments: {primaryText}'
                }, {
                    layerIds: [1500],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2751],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2900],
                    replacementFormat: '{primaryText}'
                }
            ],
            layers: [
                { name: 'rmsseg', id: 1299 },
                { name: 'county', id: 1 },
                { name: 'district', id: 2 },
                { name: 'municipality', id: 3 },
                { name: 'planningPartner', id: 4 },
                { name: 'congressDistrict', id: 5 },
                { name: 'senateDistrict', id: 6 },
                { name: 'houseDistrict', id: 7 },
                { name: 'intersection', id: 2902 },
                { name: 'bridgesAll', id: 1593 },
                { name: 'mpmsProjectsAll', id: 2751 },
                { name: 'hopInternal', id: 9144 },
                { name: 'hopExternal', id: 7826 },
                { name: 'tmsSites', id: 2611 },
                { name: 'petl', id: 2701 },
                { name: 'assistantAreasWinter', id: 3006 },
                { name: 'assistantAreasSummer', id: 3007 },
                { name: 'zipCode', id: 10 },
                { name: 'schoolDistrict', id: 9 },
                { name: 'stormwater', id: 7029 },
                { name: 'sapCYPlanSnapshot', id: 110445 }
            ],
            tsmoRegions: [
                {
                    type: 'tsmo',
                    name: 'western',
                    title: 'Western',
                    fullTitle: 'TSMO Western Region',
                    districtNumbers: ['01', '10', '11', '12']
                },
                {
                    type: 'tsmo',
                    name: 'central',
                    title: 'Central',
                    fullTitle: 'TSMO Central Region',
                    districtNumbers: ['02', '03', '09']
                },
                {
                    type: 'tsmo',
                    name: 'eastern',
                    title: 'Eastern',
                    fullTitle: 'TSMO Eastern Region',
                    districtNumbers: ['04', '05', '08']
                },
                {
                    type: 'tsmo',
                    name: 'southeastern',
                    title: 'Southeastern',
                    fullTitle: 'TSMO Southeastern Region',
                    districtNumbers: ['06']
                }
            ],
            paRoads: 'not used',
            geometryServiceUrl: 'https://gistest.penndot.pa.gov/gis/rest/services/Utilities/Geometry/GeometryServer',
            videoLogBaseUrl: 'https://gistest.penndot.pa.gov/videolog/',
            videoLogImagesLocation: 'https://gistest.penndot.pa.gov/videologimages',
            routingApiKey: 'AAPKbadd75f72f744f3e911d0f31cd8c6811ivUpHDn1z7baDzD5XcjoOUohYXlcpyMcsswRn2yFaK7AtZzqxoFmMDT1I_NpW3EH',
            petlCategoryId: 802,
            dataDictionaryApi: 'https://pdstgisweb.penndot.pa.gov/mapcore/api_v1/layers/1/' //'https://pdstgisweb.penndot.pa.gov/DataDictionary/api/'
        },
        test_internal: {
            production: false,
            appName: 'MapCore',
            appId: 0,
            pdauthAppName: 'MapCore',
            deepLinkBaseUrl: null,
            apiBaseUrl: 'https://pdstgisweb.penndot.pa.gov/mapcore/api',
            printTimeout: 3600000,
            externalLayerFilterEnabled: false,
            geocodeServerUrl: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
            geocodeStartingLocation: '-76.930,40.237',
            googleMapApiUrl: 'https://maps.googleapis.com/maps/api/js?v=3.exp',
            googleMapApiKey: 'client=gme-penndotinfosystems&channel=MapCore',
            gisSearch: { baseUrl: '' },
            bingBasemaps: {
                key: 'AoY639QLAP- klpOcnuspHmBA79ZECKfeULw8NwsZbSipcKHfBmglAPmbtdsF7Umi',
                thumbnails: {
                    hybrid: 'https://pdstgisweb.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-hybrid.jpg',
                    street: 'https://pdstgisweb.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-street.jpg',
                    imagery: 'https://pdstgisweb.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-imagery.jpg'
                }
            },
            ags: {
                baseUrl: 'https://pdstgisweb.penndot.pa.gov/gisgp',
                exportEndpoint: '/rest/services/mapcore/mapcoregeoprocessing/GPServer/extract'
            },
            pennDotBaseMap: {
                tileUrl: 'https://pdprgisweb.penndot.pa.gov/gis/rest/services/basemaps/penndotbasemap/MapServer/tile',
                thumbnailTile: '/7/48/36',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'PennDOT'
            },
            pennDotPrintBaseMapUrl: 'https://pdstgisweb.penndot.pa.gov/gisgp/rest/services/basemaps/printbasemap/MapServer',
            featureSearchKeys: [
                { prefix: 'BRIDGE_ID', column: 'bridge_id' },
                { prefix: 'BRKEY', column: 'brkey' },
                { prefix: 'MPMS PROJECT', column: 'project_id' },
                { prefix: 'SAP NOTIFICATION', column: 'notification_no' },
                { prefix: 'SR', column: 'st_rt_no' },
                { pipes: true, columns: ['cty_code', 'st_rt_no', 'seg_no'] }
            ],
            sapLayerIds: [16, 3970, 18],
            searchReplacement: [
                {
                    layerIds: [16],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Planned'
                }, {
                    layerIds: [17, 3970],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Unplanned'
                }, {
                    layerIds: [18],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Completed'
                }, {
                    layerIds: [1200],
                    replacementFormat: 'RMS Segments: {primaryText}'
                }, {
                    layerIds: [1500],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2751],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2900],
                    replacementFormat: '{primaryText}'
                }
            ],
            layers: [
                { name: 'rmsseg', id: 1299 },
                { name: 'county', id: 1 },
                { name: 'district', id: 2 },
                { name: 'municipality', id: 3 },
                { name: 'planningPartner', id: 4 },
                { name: 'congressDistrict', id: 5 },
                { name: 'senateDistrict', id: 6 },
                { name: 'houseDistrict', id: 7 },
                { name: 'intersection', id: 2902 },
                { name: 'bridgesAll', id: 1593 },
                { name: 'mpmsProjectsAll', id: 2751 },
                { name: 'hopInternal', id: 9144 },
                { name: 'hopExternal', id: 7826 },
                { name: 'tmsSites', id: 2611 },
                { name: 'petl', id: 2701 },
                { name: 'assistantAreasWinter', id: 3006 },
                { name: 'assistantAreasSummer', id: 3007 },
                { name: 'zipCode', id: 10 },
                { name: 'stormwater', id: 7029 },
                { name: 'sapCYPlanSnapshot', id: 110445 }
            ],
            tsmoRegions: [
                {
                    type: 'tsmo',
                    name: 'western',
                    title: 'Western',
                    fullTitle: 'TSMO Western Region',
                    districtNumbers: ['01', '10', '11', '12']
                },
                {
                    type: 'tsmo',
                    name: 'central',
                    title: 'Central',
                    fullTitle: 'TSMO Central Region',
                    districtNumbers: ['02', '03', '09']
                },
                {
                    type: 'tsmo',
                    name: 'eastern',
                    title: 'Eastern',
                    fullTitle: 'TSMO Eastern Region',
                    districtNumbers: ['04', '05', '08']
                },
                {
                    type: 'tsmo',
                    name: 'southeastern',
                    title: 'Southeastern',
                    fullTitle: 'TSMO Southeastern Region',
                    districtNumbers: ['06']
                }
            ],
            paRoads: 'not used',
            geometryServiceUrl: 'https://pdstgisweb.penndot.pa.gov/gis/rest/services/Utilities/Geometry/GeometryServer',
            videoLogBaseUrl: 'https://pdstgisweb.penndot.pa.gov/videolog/',
            videoLogImagesLocation: 'https://pdstgisweb.penndot.pa.gov/videologimages',
            routingApiKey: 'AAPKbadd75f72f744f3e911d0f31cd8c6811ivUpHDn1z7baDzD5XcjoOUohYXlcpyMcsswRn2yFaK7AtZzqxoFmMDT1I_NpW3EH',
            petlCategoryId: 802,
            dataDictionaryApi: 'https://pdstgisweb.penndot.pa.gov/mapcore/api_v1/layers/1/' //'https://pdstgisweb.penndot.pa.gov/DataDictionary/api/'
        },
        prod: {
            production: true,
            appName: 'MapCore',
            appId: 0,
            pdauthAppName: 'MapCore',
            deepLinkBaseUrl: null,
            apiBaseUrl: 'https://gis.penndot.pa.gov/mapcore/api',
            printTimeout: 3600000,
            externalLayerFilterEnabled: false,
            geocodeServerUrl: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
            geocodeStartingLocation: '-76.930,40.237',
            googleMapApiUrl: 'https://maps.googleapis.com/maps/api/js?v=3.exp',
            googleMapApiKey: 'client=gme-penndotinfosystems&channel=MapCore',
            gisSearch: { baseUrl: '' },
            bingBasemaps: {
                key: 'AoY639QLAP- klpOcnuspHmBA79ZECKfeULw8NwsZbSipcKHfBmglAPmbtdsF7Umi',
                thumbnails: {
                    hybrid: 'https://gis.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-hybrid.jpg',
                    street: 'https://gis.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-street.jpg',
                    imagery: 'https://gis.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-imagery.jpg'
                }
            },
            ags: {
                baseUrl: 'https://gis.penndot.pa.gov/gisgp',
                exportEndpoint: '/rest/services/mapcore/mapcoregeoprocessing/GPServer/extract'
            },
            pennDotBaseMap: {
                tileUrl: 'https://gis.penndot.pa.gov/gis/rest/services/basemaps/penndotbasemap/MapServer/tile',
                thumbnailTile: '/7/48/36',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'PennDOT'
            },
            pennDotPrintBaseMapUrl: 'https://gis.penndot.pa.gov/gisgp/rest/services/basemaps/printbasemap/MapServer',
            featureSearchKeys: [
                { prefix: 'BRIDGE_ID', column: 'bridge_id' },
                { prefix: 'BRKEY', column: 'brkey' },
                { prefix: 'MPMS PROJECT', column: 'project_id' },
                { prefix: 'SAP NOTIFICATION', column: 'notification_no' },
                { prefix: 'SR', column: 'st_rt_no' },
                { pipes: true, columns: ['cty_code', 'st_rt_no', 'seg_no'] }
            ],
            sapLayerIds: [16, 3970, 18],
            searchReplacement: [
                {
                    layerIds: [16],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Planned'
                }, {
                    layerIds: [17, 3970],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Unplanned'
                }, {
                    layerIds: [18],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Completed'
                }, {
                    layerIds: [1200],
                    replacementFormat: 'RMS Segments: {primaryText}'
                }, {
                    layerIds: [1500],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2751],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2900],
                    replacementFormat: '{primaryText}'
                }
            ],
            layers: [
                { name: 'rmsseg', id: 1299 },
                { name: 'county', id: 1 },
                { name: 'district', id: 2 },
                { name: 'municipality', id: 3 },
                { name: 'planningPartner', id: 4 },
                { name: 'congressDistrict', id: 5 },
                { name: 'senateDistrict', id: 6 },
                { name: 'houseDistrict', id: 7 },
                { name: 'intersection', id: 2902 },
                { name: 'bridgesAll', id: 1592 },
                { name: 'mpmsProjectsAll', id: 2751 },
                { name: 'hopInternal', id: 9144 },
                { name: 'hopExternal', id: 7826 },
                { name: 'tmsSites', id: 2611 },
                { name: 'petl', id: 2701 },
                { name: 'assistantAreasWinter', id: 3006 },
                { name: 'assistantAreasSummer', id: 3007 },
                { name: 'zipCode', id: 10 },
                { name: 'schoolDistrict', id: 9 },
                { name: 'stormwater', id: 7029 },
                { name: 'sapCYPlanSnapshot', id: 489868 }
            ],
            tsmoRegions: [
                {
                    type: 'tsmo',
                    name: 'western',
                    title: 'Western',
                    fullTitle: 'TSMO Western Region',
                    districtNumbers: ['01', '10', '11', '12']
                },
                {
                    type: 'tsmo',
                    name: 'central',
                    title: 'Central',
                    fullTitle: 'TSMO Central Region',
                    districtNumbers: ['02', '03', '09']
                },
                {
                    type: 'tsmo',
                    name: 'eastern',
                    title: 'Eastern',
                    fullTitle: 'TSMO Eastern Region',
                    districtNumbers: ['04', '05', '08']
                },
                {
                    type: 'tsmo',
                    name: 'southeastern',
                    title: 'Southeastern',
                    fullTitle: 'TSMO Southeastern Region',
                    districtNumbers: ['06']
                }
            ],
            paRoads: 'https://gis.penndot.pa.gov/gis/rest/services/mapcore/paroads/MapServer',
            geometryServiceUrl: 'https://gis.penndot.pa.gov/gis/rest/services/Utilities/Geometry/GeometryServer',
            videoLogBaseUrl: 'https://gis.penndot.pa.gov/videolog/',
            videoLogImagesLocation: 'https://gis.penndot.pa.gov/videologimages',
            routingApiKey: 'AAPKbadd75f72f744f3e911d0f31cd8c6811ivUpHDn1z7baDzD5XcjoOUohYXlcpyMcsswRn2yFaK7AtZzqxoFmMDT1I_NpW3EH',
            petlCategoryId: 802,
            dataDictionaryApi: 'https://pdprgisweb.penndot.pa.gov/mapcore/api_v1/layers/1/' //'https://pdprgisweb.penndot.pa.gov/DataDictionary/api/'
        },
        prod_internal: {
            production: true,
            appName: 'MapCore',
            appId: 0,
            pdauthAppName: 'MapCore',
            deepLinkBaseUrl: null,
            apiBaseUrl: 'https://pdprgisweb.penndot.pa.gov/mapcore/api',
            printTimeout: 3600000,
            externalLayerFilterEnabled: false,
            geocodeServerUrl: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
            geocodeStartingLocation: '-76.930,40.237',
            googleMapApiUrl: 'https://maps.googleapis.com/maps/api/js?v=3.exp',
            googleMapApiKey: 'client=gme-penndotinfosystems&channel=MapCore',
            gisSearch: { baseUrl: '' },
            bingBasemaps: {
                key: 'AoY639QLAP- klpOcnuspHmBA79ZECKfeULw8NwsZbSipcKHfBmglAPmbtdsF7Umi',
                thumbnails: {
                    hybrid: 'https://pdprgisweb.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-hybrid.jpg',
                    street: 'https://pdprgisweb.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-street.jpg',
                    imagery: 'https://pdprgisweb.penndot.pa.gov/mapcore/api/assets/bing-basemap-thumbnails/bing-imagery.jpg'
                }
            },
            ags: {
                baseUrl: 'https://pdprgisweb.penndot.pa.gov/gisgp',
                exportEndpoint: '/rest/services/mapcore/mapcoregeoprocessing/GPServer/extract'
            },
            pennDotBaseMap: {
                tileUrl: 'https://pdprgisweb.penndot.pa.gov/gis/rest/services/basemaps/penndotbasemap/MapServer/tile',
                thumbnailTile: '/7/48/36',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'PennDOT'
            },
            pennDotPrintBaseMapUrl: 'https://pdprgisweb.penndot.pa.gov/gisgp/rest/services/basemaps/printbasemap/MapServer',
            featureSearchKeys: [
                { prefix: 'BRIDGE_ID', column: 'bridge_id' },
                { prefix: 'BRKEY', column: 'brkey' },
                { prefix: 'MPMS PROJECT', column: 'project_id' },
                { prefix: 'SAP NOTIFICATION', column: 'notification_no' },
                { prefix: 'SR', column: 'st_rt_no' },
                { pipes: true, columns: ['cty_code', 'st_rt_no', 'seg_no'] }
            ],
            sapLayerIds: [16, 3970, 18],
            searchReplacement: [
                {
                    layerIds: [16],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Planned'
                }, {
                    layerIds: [17, 3970],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Unplanned'
                }, {
                    layerIds: [18],
                    replacementFormat: '{sapStatus} {nocoPayroll}: {sapNotif}',
                    sapStatus: 'SAP-PM - Completed'
                }, {
                    layerIds: [1200],
                    replacementFormat: 'RMS Segments: {primaryText}'
                }, {
                    layerIds: [1500],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2751],
                    replacementFormat: '{primaryText}'
                }, {
                    layerIds: [2900],
                    replacementFormat: '{primaryText}'
                }
            ],
            layers: [
                { name: 'rmsseg', id: 1299 },
                { name: 'county', id: 1 },
                { name: 'district', id: 2 },
                { name: 'municipality', id: 3 },
                { name: 'planningPartner', id: 4 },
                { name: 'congressDistrict', id: 5 },
                { name: 'senateDistrict', id: 6 },
                { name: 'houseDistrict', id: 7 },
                { name: 'intersection', id: 2902 },
                { name: 'bridgesAll', id: 1592 },
                { name: 'mpmsProjectsAll', id: 2751 },
                { name: 'hopInternal', id: 9144 },
                { name: 'hopExternal', id: 7826 },
                { name: 'tmsSites', id: 2611 },
                { name: 'petl', id: 2701 },
                { name: 'assistantAreasWinter', id: 3006 },
                { name: 'assistantAreasSummer', id: 3007 },
                { name: 'zipCode', id: 10 },
                { name: 'stormwater', id: 7029 },
                { name: 'sapCYPlanSnapshot', id: 489868 }
            ],
            tsmoRegions: [
                {
                    type: 'tsmo',
                    name: 'western',
                    title: 'Western',
                    fullTitle: 'TSMO Western Region',
                    districtNumbers: ['01', '10', '11', '12']
                },
                {
                    type: 'tsmo',
                    name: 'central',
                    title: 'Central',
                    fullTitle: 'TSMO Central Region',
                    districtNumbers: ['02', '03', '09']
                },
                {
                    type: 'tsmo',
                    name: 'eastern',
                    title: 'Eastern',
                    fullTitle: 'TSMO Eastern Region',
                    districtNumbers: ['04', '05', '08']
                },
                {
                    type: 'tsmo',
                    name: 'southeastern',
                    title: 'Southeastern',
                    fullTitle: 'TSMO Southeastern Region',
                    districtNumbers: ['06']
                }
            ],
            paRoads: 'not used',
            geometryServiceUrl: 'https://pdprgisweb.penndot.pa.gov/gis/rest/services/Utilities/Geometry/GeometryServer',
            videoLogBaseUrl: 'https://pdprgisweb.penndot.pa.gov/videolog/',
            videoLogImagesLocation: 'https://pdprgisweb.penndot.pa.gov/videologimages',
            routingApiKey: 'AAPKbadd75f72f744f3e911d0f31cd8c6811ivUpHDn1z7baDzD5XcjoOUohYXlcpyMcsswRn2yFaK7AtZzqxoFmMDT1I_NpW3EH',
            petlCategoryId: 802,
            dataDictionaryApi: 'https://pdprgisweb.penndot.pa.gov/mapcore/api_v1/layers/1/' //'https://pdprgisweb.penndot.pa.gov/DataDictionary/api/'
        }
    };
    return Environment;
}());
export var environment = Environment.init;
